import React from 'react';
// eslint-disable-next-line jira/restricted/redux
// eslint-disable-next-line jira/restricted/redux
import type { Store } from 'redux';
import type PlanIncrementType from '@jira/spa-apps__advanced-roadmaps-plan-increment/src/PlanIncrement.tsx';
import { markAsProductBundleReady } from '@jira/platform__spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@jira/platform__spa/src/view/lazy-page/index.tsx';
import { lazyForPaint, type LazyComponent } from '@atlassian/react-loosely-lazy';

export const LazyPlanIncrement: LazyComponent<({ store }: { store: Store }) => React.JSX.Element> =
	// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
	lazyForPaint<typeof PlanIncrementType>(
		() =>
			markAsProductBundleReady(
				import(
					/* webpackChunkName: "async-plan-increment", jiraSpaEntry: "async-plan-increment" */ '@jira/spa-apps__advanced-roadmaps-plan-increment/src/PlanIncrement.tsx'
				),
			),
		{ ssr: false },
	);

export const PlanIncrement = (): React.JSX.Element => (
	<LazyPage Page={LazyPlanIncrement} pageId="plan-increment" shouldShowSpinner />
);
